import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';

export class TransitionWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };

    setTimeout(() => {
      this.setState({
        show: true
      });
    }, this.props.timeout || 10);
  }

  render() {
    let { children } = this.props;
    let { show } = this.state;
    return (
      <CSSTransition classNames="fade" in={show} timeout={300}>
        {() => <div className="fade">{children}</div>}
      </CSSTransition>
    );
  }
}
